var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShowPassword(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.323 12.5c2.693-2.5 6.274-4.499 10.674-4.499 4.4 0 7.98 2 10.674 4.5C33.365 15 35.164 18 35.996 20c-.832 2-2.632 5-5.325 7.5-2.694 2.5-6.274 4.499-10.674 4.499-4.4 0-7.98-2-10.674-4.5C6.629 25 4.829 22 3.998 20c.831-2 2.631-5 5.325-7.5zm10.674-6.499c-5.05 0-9.093 2.3-12.037 5.037C5.036 13.751 3.08 17 2.155 19.231a1.988 1.988 0 000 1.538c.925 2.23 2.88 5.48 5.805 8.193 2.944 2.737 6.987 5.037 12.037 5.037 5.05 0 9.093-2.3 12.036-5.037 2.925-2.719 4.881-5.962 5.812-8.193a1.987 1.987 0 000-1.538c-.93-2.23-2.887-5.48-5.812-8.193-2.943-2.737-6.987-5.037-12.036-5.037zm-6 13.999a6 6 0 1112 0 6 6 0 01-12 0zm14 0a8 8 0 10-16 0 8 8 0 0016 0z"
  })));
}

export default SvgShowPassword;